import { prepareFilterQuery } from "./utils";

export default ({ getFn, filter, id }) => {
    return getFn({
        param: prepareFilterQuery(filter),
        [id.name]: id.value,
    });
};
